import { TextField } from "@material-ui/core"
import { graphql, useStaticQuery } from "gatsby"
import React, { useState } from "react"
import useForm from "react-hook-form"
import InputMaterial from "../../../components/atoms/input-material/input-material";
import LayoutModal from "../../../components/organisms/layoutModal/layout-modal"
import useBrowserMode from "../../../hooks/useBrowserMode"
import useHomeLinkMode from "../../../hooks/useHomeLinkMode"
import useLocaleMode from "../../../hooks/useLocaleMode"
import AuthService from "../../../services/authentication"
import ProfileService from "../../../services/profile"
import { RECOVERY_EMAIL } from '../../../state/constants/apiConstants'
import { localStorage } from "../../../state/utils/storage"
import "./modal-auth.scss"
import ReCAPTCHA from "react-google-recaptcha"
import { axiosInstance } from "../../../services/axiosInstance"
import Alert from "../../atoms/alert/alert"
import SamplesService from "../../../services/samples"
import SessionService from "../../../services/session"
import ModalAuthProspect from "../modal-auth-prospect/modal-auth-prospect";

const ModalAuth = ({ hideAction, title, fromBenefits, validateCoverage, showModalCoverage, isWebinar = false, prospectRegister = false, setProspectEmail = () => { }, buttonProspect = "Finalizar" }, ...props) => {

  const { locale } = useLocaleMode();
  // const labelCorreo = "¿Cuál es tu correo electrónico?";
  const labelCorreo = `Ingresa con tu correo o celular`;
  const labelPassword = "Ingresa tu contraseña";
  const labelCellPhone = "¿Cuál es tu celular?";
  const { handleSubmit, register, errors } = useForm();
  const [emailValid, setEmailValid] = useState(false);
  const [inputPassword, setInputPassword] = useState(false);
  const [userDontExist, setUserDontExist] = useState(false);
  const [cellPhoneActive, setCellPhoneActive] = useState(false);
  const [cellPhoneValue, setCellPhoneValue] = useState();
  const [cellPhoneSend, setCellPhonSend] = useState(false);
  const [cellPhoneSendError, setCellPhonSendError] = useState(null);
  // const [recaptchaValue, setRecaptchaValue] = useState("");
  const [messageError, setMessageError] = useState(null);
  const { homeLink } = useHomeLinkMode();

  const [formProspect, setFormProspect] = React.useState(false);
  const [currentInputValue, setCurrentInputValue] = React.useState("");
  const { isBrowser } = useBrowserMode();

  const recaptchaRef = React.useRef(null);

  const handleReloadCaptcha = async () => {
    if (!formProspect) {
      await recaptchaRef.current.execute();
    }
  }

  const handleDataLayerError = (error = "") => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      'event': 'ga_event_consultorio',
      'category': 'Academia TENA',
      'action': props.isComment ? 'Opinión ::Validar datos' : 'Ver contenido:: Validar datos',
      'label': error
    })
  }

  React.useEffect(() => {
    recaptchaRef.current.execute();
    let intervalCaptcha = setTimeout(setInterval(handleReloadCaptcha, 120000), 110000);
    return () => {
      clearInterval(intervalCaptcha)
    }
  }, []);

  const result = useStaticQuery(
    graphql`
      query SelectorPaisesPrefix {
        allContentfulTenaPaises(sort: {fields: orden, order: ASC}, filter: {node_locale: {eq: "es-CO"}}) {
          nodes {
            prefijoTelefonico
            codigoDeDosLetras
            pdfCobertura {
              file {
                url
              }
            }
          }
        }
      }
    `
  );

  const filteredCountry = result && isBrowser &&
    result.allContentfulTenaPaises.nodes.filter(country => locale.includes(country.codigoDeDosLetras));
  const countryPrefix = filteredCountry[0].prefijoTelefonico;
  const urlPDF = filteredCountry[0].pdfCobertura ? filteredCountry[0].pdfCobertura.file.url : null;

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  const navigateToRegister = () => window.location.href = homeLink + 'registro';
  const actionEmail = values => {
    const email = values.input;
    if (email) {
      const payload = {
        email: email,
        indicative: countryPrefix,
        captcha: recaptchaRef.current.getValue(),
      };
      ProfileService.validateEmail(
        payload,
        restData => {
          const { data } = restData;
          if (data.status === 200) {
            recaptchaRef.current.execute();
            setCellPhoneActive(false)
            isWebinar && handleDataLayerError(data.userMessage)
            if (
              restData.data.data &&
              (restData.data.data.estado === "MIGRACION" || restData.data.data.estado === "TEMPORAL")
            ) {
              sessionStorage.setItem(
                "muid", //Migrated User ID
                JSON.stringify(btoa(restData.data.data.userId.toString()))
              );
              sessionStorage.setItem("loyalEmail", email);
              sessionStorage.setItem("isInterestedUser", "true");
              window.location.href = homeLink + "registro/?s=code";
            } else {
              setMessageError(null);
              setEmailValid(email)
            }
          } else if (data.status === 400) {
            isWebinar && handleDataLayerError(data.userMessage)
            if (data.errorCode === "DEM006") {
              setCellPhoneActive(false)
              setUserDontExist(true)
              setMessageError(null)
            } else if (data.errorCode === "DEM023") {
              sessionStorage.setItem("userDataVerification", JSON.stringify(data.data));
              if (Number.isInteger(parseInt(email))) {
                window.location.href = homeLink + "registro/verificacion/?rv=SMS"
              } else {
                window.location.href = homeLink + "registro/verificacion/?rv=EMAIL"
              }

            }
          }
        },
        setMessageError
      )
    }
  };

  const handleSendCellPhone = () => {
    if (cellPhoneValue) {
      const payload = {
        cellPhone: `${countryPrefix}${cellPhoneValue}`
      };
      axiosInstance.post(RECOVERY_EMAIL, payload).then(restData => {
        const { data } = restData;
        if (data.status === 200) {
          setCellPhonSend(true);
          setCellPhoneValue("");
        }
        else if (data.status === 400 || data.status === 500) {
          setCellPhonSendError(data.userMessage);
        }
      }).catch(err => {
        console.log(err);
      })
    }
  };

  const actionPassword = values => {
    const password = values.password;
    const payload = {
      email: emailValid,
      password: password,
      indicative: countryPrefix,
      captcha: recaptchaRef.current.getValue(),
    };
    ProfileService.authLogin(payload, restData => {
      const { data } = restData;
      const authData = data.data;
      if (data.status === 200) {
        AuthService.userInfo(
          authData.tokenData.idToken
        ).then((resp) => {
          if (resp.status === 200) {
            isWebinar && handleDataLayerError(data.userMessage)
            const userData = resp.data;
            localStorage.setItem("tokenData", authData.tokenData);
            localStorage.setItem(
              "userName",
              `${userData.name} ${userData.lastName}`
            );
            localStorage.setItem("userData", userData);
            sessionStorage.removeItem("tokenData");
            sessionStorage.removeItem("userName");
            sessionStorage.removeItem("userData");
            if (fromBenefits) {
              // sessionStorage.setItem("isInterestedUser", "true")
              // window.location.href = homeLink + "registro/?s=code"
              if (!userData.choseInterest) {
                sessionStorage.setItem('fromBenefits', true);
                window.location.href = homeLink + 'registro/intereses/?s=benefits'
              }
              else {
                window.location.href = homeLink + "beneficios/acumula-puntos/"
              }

            }

            if (validateCoverage() === false) {
              hideAction();
              showModalCoverage()
            } else {
              locale === "es-CO" ? (window.location.href = homeLink + "muestra-gratis/confirmacion/") : (window.location.href = homeLink + "pide-tu-muestra/confirmacion/")
            }
          }
        })
      } else if (data.status === 400) {
        setMessageError(data.userMessage);
        isWebinar && handleDataLayerError(data.userMessage)
      }
    })
  };

  const actionRegister = values => {
    const email = values.input;

    if (!fromBenefits && !isWebinar && !prospectRegister) {
      const samples = SessionService.getSamples();
      const formatSamples = samples && samples.map(sample => {
        return {
          id: sample.id,
          size: sample.size,
          destiny: sample.destiny,
          name: sample.name
        }
      })
      SamplesService.sendSamplesTemporal(email, countryPrefix, formatSamples, samples[0].img, sucess => {
        if (sucess.data.status === 200) {
          localStorage.removeItem('samples');
          sessionStorage.setItem("loyalEmail", email)
          window.location.href = homeLink + "registro/?s=sample"
        } else {
          alert('Ha ocurrido un error en la solicitud de muestras');
        }
      }, error => {
        console.log('error', error);
        alert('Ha ocurrido un error en la solicitud de muestras');
      })

    } else if (isWebinar && !prospectRegister) {
      sessionStorage.setItem("loyalEmail", email);
      window.location.href = homeLink + "registro/?s=webinar";
    } else if (prospectRegister) {
      setCurrentInputValue(email);
      setFormProspect(true);
    } else {
      sessionStorage.setItem("loyalEmail", email);
      sessionStorage.setItem("isInterestedUser", "true");
      window.location.href = homeLink + "registro/?s=code";
    }
  }

  return (
    <LayoutModal onClose={hideAction}>
      {!formProspect ? <form
        className="f-modal-auth"
        onSubmit={handleSubmit(emailValid ? inputPassword ? actionPassword : () => setInputPassword(true) : userDontExist ? actionRegister : actionEmail)}
      >
        <ReCAPTCHA
          ref={recaptchaRef}
          size="invisible"
          sitekey="6LdO87YUAAAAADiKJPkEhXpUH7_JthcTOF1iVMnx"
        />
        <div className="f-card-modal-head">
          <span className="f-card-modal-head-icon" onClick={hideAction}>
            X
          </span>
        </div>
        <h3 className="f-modal-auth-title">
          {title !== undefined && title !== null
            ? title
            : <>Para solicitar muestras de productos <span>TENA,</span> debes ingresar a tu cuenta o registrarte.</>}
        </h3>
        <p className="f-modal-auth-copy">
          {
            inputPassword ? <>Ya <span>te encuentras en nuestra base de datos, ingresa tu contraseña</span> para continuar</>
              : userDontExist ? <>Aún <span>no te encuentras en nuestra base de datos,</span> debes completar el proceso de registro.</>
                : <>Queremos validar que <span>te encuentras en nuestra base de datos, ingresa tu correo o número de celular</span> para continuar</>
          }

        </p>
        <div className="f-modal-auth-input">
          {!inputPassword && <InputMaterial
            change={() => setMessageError(null)}
            classes="f-form-input"
            register={register({
              required: "Por favor digite su correo",
            })}
            name="input"
            type="text"
            label={labelCorreo}
            placeholder={labelCorreo}
            errors={errors}
            messageError={messageError}
            resetError={() => setMessageError(null)}
            disabled={emailValid || userDontExist}
          />}
          {emailValid && !inputPassword &&
            <Alert
              alertType="info"
              description={isWebinar ?
                "Ya te encuentras en nuestro sistema, haz clic en el botón continuar para iniciar sesión." :
                "Ya te encuentras en nuestro sistema, haz clic en el botón continuar para actualizar tus datos."
              }
            />
          }
          {emailValid && inputPassword && (
            <InputMaterial
              change={() => setMessageError(null)}
              classes="f-form-input"
              register={register({
                required: "Por favor digite su contraseña",

              })}
              name="password"
              type="password"
              label={labelPassword}
              placeholder={labelPassword}
              errors={errors}
              messageError={messageError}
              resetError={() => setMessageError(null)}
            />
          )}
          {!emailValid && !inputPassword && <span className="f-modal-auth-field-forget" onClick={() => setCellPhoneActive(true)}>
            ¿Olvidaste tu correo electrónico?
          </span>}
          {emailValid && inputPassword && <a href={homeLink + "autenticacion/recuperar-contrasena/"} className="f-modal-auth-field-forget" >
            ¿Olvidaste tu contraseña?
          </a>}
        </div>
        {
          (!inputPassword && !userDontExist && urlPDF && !fromBenefits) && <p className="f-modal-auth-copy">
            Valida si tu ciudad tiene cobertura para el envío de muestras gratis
            <a href={urlPDF} target="_blank" download> aquí</a>
          </p>}
        <div>

        </div>

        <div className="f-modal-auth-field">

          <button
            type="submit"
            className="f-modal-auth-field-button"
            disabled={errors[emailValid ? "password" : "input"]}
          >
            {!emailValid ? userDontExist ? "REGÍSTRATE" : "SIGUIENTE" : inputPassword ? "INICIAR SESIÓN" : "CONTINUAR"}
          </button>
        </div>
        <div className={cellPhoneActive ? "f-modal-auth-field f-modal-auth-field-cell active" : "f-modal-auth-field f-modal-auth-field-cell "}>
          <p>Ingresa tu número celular para recuperar tu correo electrónico.</p>
          <TextField
            name={"cellPhone"}
            value={cellPhoneValue}
            onChange={e => {
              setCellPhoneValue(e.target.value);
              setCellPhonSend(false);
              setCellPhonSendError(null);
            }}
            type={"number"}
            placeholder={labelCellPhone}
            className="f-form-input"
            color="secondary"
            variant="outlined"
          />
          {cellPhoneSend && <span className="f-modal-auth-field-cell-answer">Hemos enviado tu correo electrónico al número celular.</span>}
          {cellPhoneSendError && <span className="f-modal-auth-field-cell-answer">{cellPhoneSendError}</span>}
          <button
            type="button"
            onClick={handleSendCellPhone}
            className="f-modal-auth-field-button"
          >
            ENVIAR
          </button>
        </div>
      </form>
        :
        <div className="f-modal-auth--prospect">
          <div className="f-card-modal-head">
            <span className="f-card-modal-head-icon" onClick={hideAction}>
              X
          </span>
          </div>
          <h3 className="f-modal-auth-title">
            Para nosotros es muy importante tu opinión, déjanos tus datos.
        </h3>
          <ModalAuthProspect
            buttonProspect={buttonProspect}
            inputValue={currentInputValue}
            setProspectEmail={setProspectEmail}
            hideModal={() => { hideAction() }}
            isWebinar={isWebinar}
            isComment={props.isComment}
          />
        </div>

      }
    </LayoutModal>
  )
};

export default ModalAuth;